import { MockFactory } from '@tino-frontend/mocks'
import { PurchaseIntentionResponse } from '@types'
import { Frequency, Plan, PurchaseIntentionStatus } from 'constants/enums'

export const JOHN_WICK_SELLER_ID = '0ab0bc59-43db-487c-b0ec-898625a88f92'

export const purchaseIntentionAPIMock =
  new MockFactory<PurchaseIntentionResponse>({
    id: 'purchase-intention-id',
    supplier_name: 'Tino ACME',
    supplier_company_id: JOHN_WICK_SELLER_ID,
    merchant_company_id: 'acb9969b-a8b1-4979-aa8e-a6be12edb34e',
    merchant_document_number: '06331795000105',
    email: 'celtino1@tino.com.br',
    url_callback: 'https://www.app.tino.com.br/',
    external_id: 'extenal_id-test-payment-link-1',
    amount_cents: 120000,
    contact: {
      phone: '5511911111111',
      channel: 'whatsapp',
    },
    banner: {},
    has_pending_otp_verify: false,
    discount_amount_cents: 0,
    payment_options: {
      [Plan.WEEKLY]: [
        {
          id: '7-option-1',
          total_amount_cents: 120000,
          subtotal_amount_cents: 120000,
          discount_amount_cents: 0,
          interest_amount_cents: 0,
          interest_rate_bps: 0,
          installment_quantity: 1,
          installments_interval: [7],
          installments: [
            {
              order: 1,
              expected_settlement_date: '2023-05-02',
              total_amount_cents: 40000,
              subtotal_amount_cents: 40000,
              interest_amount_cents: 0,
              calendar_day: 28,
            },
          ],
          available: true,
          merchant_service_fee_amount_cents: 0,
          merchant_service_fee_rate_bps: 0,
        },
        {
          id: '7-option-2',
          total_amount_cents: 120000,
          subtotal_amount_cents: 120000,
          discount_amount_cents: 0,
          interest_amount_cents: 0,
          interest_rate_bps: 0,
          installment_quantity: 2,
          installments_interval: [7, 14],
          installments: [
            {
              order: 1,
              expected_settlement_date: '2023-05-02',
              total_amount_cents: 40000,
              subtotal_amount_cents: 40000,
              interest_amount_cents: 0,
              calendar_day: 28,
            },
            {
              order: 2,
              expected_settlement_date: '2023-05-09',
              total_amount_cents: 40000,
              subtotal_amount_cents: 40000,
              interest_amount_cents: 0,
              calendar_day: 28,
            },
          ],
          available: true,
          merchant_service_fee_amount_cents: 0,
          merchant_service_fee_rate_bps: 0,
        },
      ],
      [Plan.BIWEEKLY]: [
        {
          id: '14-option-1',
          total_amount_cents: 120000,
          subtotal_amount_cents: 120000,
          discount_amount_cents: 0,
          interest_amount_cents: 0,
          interest_rate_bps: 0,
          installment_quantity: 1,
          installments_interval: [14],
          installments: [
            {
              order: 1,
              expected_settlement_date: '2023-05-02',
              total_amount_cents: 40000,
              subtotal_amount_cents: 40000,
              interest_amount_cents: 0,
              calendar_day: 28,
            },
          ],
          available: true,
          merchant_service_fee_amount_cents: 0,
          merchant_service_fee_rate_bps: 0,
        },
      ],
      [Plan.MONTHLY]: [
        {
          id: '28-option-1',
          total_amount_cents: 120000,
          subtotal_amount_cents: 120000,
          discount_amount_cents: 0,
          interest_amount_cents: 0,
          interest_rate_bps: 0,
          installment_quantity: 1,
          installments_interval: [28],
          installments: [
            {
              order: 1,
              expected_settlement_date: '2023-05-22',
              total_amount_cents: 40000,
              subtotal_amount_cents: 40000,
              interest_amount_cents: 0,
              calendar_day: 28,
            },
          ],
          available: true,
          merchant_service_fee_amount_cents: 0,
          merchant_service_fee_rate_bps: 0,
        },
        {
          id: '28-option-2',
          total_amount_cents: 120000,
          subtotal_amount_cents: 120000,
          discount_amount_cents: 0,
          interest_amount_cents: 0,
          interest_rate_bps: 0,
          installment_quantity: 2,
          installments_interval: [28, 56],
          installments: [
            {
              order: 1,
              expected_settlement_date: '2023-05-22',
              total_amount_cents: 40000,
              subtotal_amount_cents: 40000,
              interest_amount_cents: 0,
              calendar_day: 28,
            },
            {
              order: 2,
              expected_settlement_date: '2023-06-19',
              total_amount_cents: 40000,
              subtotal_amount_cents: 40000,
              interest_amount_cents: 0,
              calendar_day: 28,
            },
          ],
          available: true,
          merchant_service_fee_amount_cents: 0,
          merchant_service_fee_rate_bps: 0,
        },
      ],
    },
    origin: 'sdk',
    created_at: '2023-07-07T19:24:23.721429Z',
    status: PurchaseIntentionStatus.Pending,
  })

export const NewPurchaseIntentionAPIMock =
  new MockFactory<PurchaseIntentionResponse>({
    id: 'purchase-intention-id',
    supplier_name: 'Tino ACME',
    supplier_company_id: JOHN_WICK_SELLER_ID,
    merchant_company_id: 'acb9969b-a8b1-4979-aa8e-a6be12edb34e',
    merchant_document_number: '06331795000105',
    email: 'celtino1@tino.com.br',
    url_callback: 'https://www.app.tino.com.br/',
    external_id: 'extenal_id-test-payment-link-1',
    amount_cents: 120000,
    contact: {
      phone: '5511911111111',
      channel: 'whatsapp',
    },
    banner: {},
    has_pending_otp_verify: false,
    discount_amount_cents: 0,
    is_new_payment_options_layout: true,
    payment_options: {
      [Frequency.ONE_TIME]: [
        {
          id: 'b1461063-a2c4-4a11-9f92-575a070b8e17',
          total_amount_cents: 309000,
          subtotal_amount_cents: 300000,
          interest_amount_cents: 0,
          available: false,
          interest_rate_bps: 0,
          merchant_service_fee_rate_bps: 300,
          merchant_service_fee_amount_cents: 9000,
          installment_quantity: 1,
          installments_interval: [7],
          installments: [
            {
              order: 1,
              expected_settlement_date: '2025-06-16',
              total_amount_cents: 309000,
              subtotal_amount_cents: 300000,
              interest_amount_cents: 0,
              calendar_day: 7,
            },
          ],
          discount_amount_cents: 0,
        },
        {
          id: 'c0c380c1-7fc5-4234-a175-5b95d4f4659a',
          total_amount_cents: 309000,
          subtotal_amount_cents: 300000,
          interest_amount_cents: 0,
          available: false,
          interest_rate_bps: 0,
          merchant_service_fee_rate_bps: 300,
          merchant_service_fee_amount_cents: 9000,
          installment_quantity: 1,
          installments_interval: [14],
          installments: [
            {
              order: 1,
              expected_settlement_date: '2025-06-23',
              total_amount_cents: 309000,
              subtotal_amount_cents: 300000,
              interest_amount_cents: 0,
              calendar_day: 14,
            },
          ],
          discount_amount_cents: 0,
        },
        {
          id: 'b6267100-c5a5-4e47-b65a-3e06fc1032d3',
          total_amount_cents: 304200,
          subtotal_amount_cents: 300000,
          interest_amount_cents: 0,
          available: false,
          interest_rate_bps: 0,
          merchant_service_fee_rate_bps: 140,
          merchant_service_fee_amount_cents: 4200,
          installment_quantity: 1,
          installments_interval: [21],
          installments: [
            {
              order: 1,
              expected_settlement_date: '2025-06-30',
              total_amount_cents: 304200,
              subtotal_amount_cents: 300000,
              interest_amount_cents: 0,
              calendar_day: 21,
            },
          ],
          discount_amount_cents: 0,
        },
        {
          id: 'd1b9a4f9-d26b-4891-ae22-409eb6cf05a2',
          total_amount_cents: 304200,
          subtotal_amount_cents: 300000,
          interest_amount_cents: 0,
          available: false,
          interest_rate_bps: 0,
          merchant_service_fee_rate_bps: 140,
          merchant_service_fee_amount_cents: 4200,
          installment_quantity: 1,
          installments_interval: [28],
          installments: [
            {
              order: 1,
              expected_settlement_date: '2025-07-07',
              total_amount_cents: 304200,
              subtotal_amount_cents: 300000,
              interest_amount_cents: 0,
              calendar_day: 28,
            },
          ],
          discount_amount_cents: 0,
        },
      ],
      [Frequency.TWO_TIMES]: [
        {
          id: '57ccd89c-debf-4cf9-898b-65c7fb727e2a',
          total_amount_cents: 309000,
          subtotal_amount_cents: 300000,
          interest_amount_cents: 0,
          available: false,
          interest_rate_bps: 0,
          merchant_service_fee_rate_bps: 300,
          merchant_service_fee_amount_cents: 9000,
          installment_quantity: 2,
          installments_interval: [7, 14],
          installments: [
            {
              order: 1,
              expected_settlement_date: '2025-06-16',
              total_amount_cents: 154500,
              subtotal_amount_cents: 150000,
              interest_amount_cents: 0,
              calendar_day: 7,
            },
            {
              order: 2,
              expected_settlement_date: '2025-06-23',
              total_amount_cents: 154500,
              subtotal_amount_cents: 150000,
              interest_amount_cents: 0,
              calendar_day: 14,
            },
          ],
          discount_amount_cents: 0,
        },
        {
          id: '80552588-c2e5-4a9a-9d48-84a5d01fdd13',
          total_amount_cents: 304200,
          subtotal_amount_cents: 300000,
          interest_amount_cents: 0,
          available: false,
          interest_rate_bps: 0,
          merchant_service_fee_rate_bps: 140,
          merchant_service_fee_amount_cents: 4200,
          installment_quantity: 2,
          installments_interval: [14, 28],
          installments: [
            {
              order: 1,
              expected_settlement_date: '2025-06-23',
              total_amount_cents: 152100,
              subtotal_amount_cents: 150000,
              interest_amount_cents: 0,
              calendar_day: 14,
            },
            {
              order: 2,
              expected_settlement_date: '2025-07-07',
              total_amount_cents: 152100,
              subtotal_amount_cents: 150000,
              interest_amount_cents: 0,
              calendar_day: 28,
            },
          ],
          discount_amount_cents: 0,
        },
        {
          id: 'c7be35d9-de43-477a-b2c0-80fc88e810d8',
          total_amount_cents: 306150,
          subtotal_amount_cents: 300000,
          interest_amount_cents: 0,
          available: false,
          interest_rate_bps: 0,
          merchant_service_fee_rate_bps: 205,
          merchant_service_fee_amount_cents: 6150,
          installment_quantity: 2,
          installments_interval: [21, 42],
          installments: [
            {
              order: 1,
              expected_settlement_date: '2025-06-30',
              total_amount_cents: 153075,
              subtotal_amount_cents: 150000,
              interest_amount_cents: 0,
              calendar_day: 21,
            },
            {
              order: 2,
              expected_settlement_date: '2025-07-21',
              total_amount_cents: 153075,
              subtotal_amount_cents: 150000,
              interest_amount_cents: 0,
              calendar_day: 42,
            },
          ],
          discount_amount_cents: 0,
        },
        {
          id: 'f58abe84-9fae-41c5-965e-dd950d4b0120',
          total_amount_cents: 306150,
          subtotal_amount_cents: 300000,
          interest_amount_cents: 0,
          available: false,
          interest_rate_bps: 0,
          merchant_service_fee_rate_bps: 205,
          merchant_service_fee_amount_cents: 6150,
          installment_quantity: 2,
          installments_interval: [28, 56],
          installments: [
            {
              order: 1,
              expected_settlement_date: '2025-07-07',
              total_amount_cents: 153075,
              subtotal_amount_cents: 150000,
              interest_amount_cents: 0,
              calendar_day: 28,
            },
            {
              order: 2,
              expected_settlement_date: '2025-08-04',
              total_amount_cents: 153075,
              subtotal_amount_cents: 150000,
              interest_amount_cents: 0,
              calendar_day: 56,
            },
          ],
          discount_amount_cents: 0,
        },
      ],
      [Frequency.THREE_TIMES]: [
        {
          id: 'e02b77c9-f0fb-4fe2-ad03-1d6946580455',
          total_amount_cents: 304200,
          subtotal_amount_cents: 300000,
          interest_amount_cents: 0,
          available: false,
          interest_rate_bps: 0,
          merchant_service_fee_rate_bps: 140,
          merchant_service_fee_amount_cents: 4200,
          installment_quantity: 3,
          installments_interval: [7, 14, 21],
          installments: [
            {
              order: 1,
              expected_settlement_date: '2025-06-16',
              total_amount_cents: 101400,
              subtotal_amount_cents: 100000,
              interest_amount_cents: 0,
              calendar_day: 7,
            },
            {
              order: 2,
              expected_settlement_date: '2025-06-23',
              total_amount_cents: 101400,
              subtotal_amount_cents: 100000,
              interest_amount_cents: 0,
              calendar_day: 14,
            },
            {
              order: 3,
              expected_settlement_date: '2025-06-30',
              total_amount_cents: 101400,
              subtotal_amount_cents: 100000,
              interest_amount_cents: 0,
              calendar_day: 21,
            },
          ],
          discount_amount_cents: 0,
        },
        {
          id: '0df72042-ec1a-4d80-a03e-61a127ee0288',
          total_amount_cents: 306150,
          subtotal_amount_cents: 300000,
          interest_amount_cents: 0,
          available: false,
          interest_rate_bps: 0,
          merchant_service_fee_rate_bps: 205,
          merchant_service_fee_amount_cents: 6150,
          installment_quantity: 3,
          installments_interval: [14, 28, 42],
          installments: [
            {
              order: 1,
              expected_settlement_date: '2025-06-23',
              total_amount_cents: 102050,
              subtotal_amount_cents: 100000,
              interest_amount_cents: 0,
              calendar_day: 14,
            },
            {
              order: 2,
              expected_settlement_date: '2025-07-07',
              total_amount_cents: 102050,
              subtotal_amount_cents: 100000,
              interest_amount_cents: 0,
              calendar_day: 28,
            },
            {
              order: 3,
              expected_settlement_date: '2025-07-21',
              total_amount_cents: 102050,
              subtotal_amount_cents: 100000,
              interest_amount_cents: 0,
              calendar_day: 42,
            },
          ],
          discount_amount_cents: 0,
        },
        {
          id: '44b71878-6032-4682-a97c-27d59ec7b1c5',
          total_amount_cents: 315000,
          subtotal_amount_cents: 300000,
          interest_amount_cents: 0,
          available: false,
          interest_rate_bps: 0,
          merchant_service_fee_rate_bps: 500,
          merchant_service_fee_amount_cents: 15000,
          installment_quantity: 3,
          installments_interval: [21, 42, 63],
          installments: [
            {
              order: 1,
              expected_settlement_date: '2025-06-30',
              total_amount_cents: 105000,
              subtotal_amount_cents: 100000,
              interest_amount_cents: 0,
              calendar_day: 21,
            },
            {
              order: 2,
              expected_settlement_date: '2025-07-21',
              total_amount_cents: 105000,
              subtotal_amount_cents: 100000,
              interest_amount_cents: 0,
              calendar_day: 42,
            },
            {
              order: 3,
              expected_settlement_date: '2025-08-11',
              total_amount_cents: 105000,
              subtotal_amount_cents: 100000,
              interest_amount_cents: 0,
              calendar_day: 63,
            },
          ],
          discount_amount_cents: 0,
        },
        {
          id: '993fcb79-515e-41cb-85d5-496078b9eaaa',
          total_amount_cents: 315000,
          subtotal_amount_cents: 300000,
          interest_amount_cents: 0,
          available: false,
          interest_rate_bps: 0,
          merchant_service_fee_rate_bps: 500,
          merchant_service_fee_amount_cents: 15000,
          installment_quantity: 3,
          installments_interval: [28, 56, 84],
          installments: [
            {
              order: 1,
              expected_settlement_date: '2025-07-07',
              total_amount_cents: 105000,
              subtotal_amount_cents: 100000,
              interest_amount_cents: 0,
              calendar_day: 28,
            },
            {
              order: 2,
              expected_settlement_date: '2025-08-04',
              total_amount_cents: 105000,
              subtotal_amount_cents: 100000,
              interest_amount_cents: 0,
              calendar_day: 56,
            },
            {
              order: 3,
              expected_settlement_date: '2025-09-01',
              total_amount_cents: 105000,
              subtotal_amount_cents: 100000,
              interest_amount_cents: 0,
              calendar_day: 84,
            },
          ],
          discount_amount_cents: 0,
        },
      ],
      [Frequency.FOUR_TIMES]: [
        {
          id: '973952b0-0771-4c27-acfc-e90ca8e994ba',
          total_amount_cents: 304200,
          subtotal_amount_cents: 300000,
          interest_amount_cents: 0,
          available: false,
          interest_rate_bps: 0,
          merchant_service_fee_rate_bps: 140,
          merchant_service_fee_amount_cents: 4200,
          installment_quantity: 4,
          installments_interval: [7, 14, 21, 28],
          installments: [
            {
              order: 1,
              expected_settlement_date: '2025-06-16',
              total_amount_cents: 76050,
              subtotal_amount_cents: 75000,
              interest_amount_cents: 0,
              calendar_day: 7,
            },
            {
              order: 2,
              expected_settlement_date: '2025-06-23',
              total_amount_cents: 76050,
              subtotal_amount_cents: 75000,
              interest_amount_cents: 0,
              calendar_day: 14,
            },
            {
              order: 3,
              expected_settlement_date: '2025-06-30',
              total_amount_cents: 76050,
              subtotal_amount_cents: 75000,
              interest_amount_cents: 0,
              calendar_day: 21,
            },
            {
              order: 4,
              expected_settlement_date: '2025-07-07',
              total_amount_cents: 76050,
              subtotal_amount_cents: 75000,
              interest_amount_cents: 0,
              calendar_day: 28,
            },
          ],
          discount_amount_cents: 0,
        },
        {
          id: '50942bf8-7d3e-4af6-b426-a3a73a514051',
          total_amount_cents: 306150,
          subtotal_amount_cents: 300000,
          interest_amount_cents: 0,
          available: false,
          interest_rate_bps: 0,
          merchant_service_fee_rate_bps: 205,
          merchant_service_fee_amount_cents: 6150,
          installment_quantity: 4,
          installments_interval: [14, 28, 42, 56],
          installments: [
            {
              order: 1,
              expected_settlement_date: '2025-06-23',
              total_amount_cents: 76539,
              subtotal_amount_cents: 75000,
              interest_amount_cents: 0,
              calendar_day: 14,
            },
            {
              order: 2,
              expected_settlement_date: '2025-07-07',
              total_amount_cents: 76537,
              subtotal_amount_cents: 75000,
              interest_amount_cents: 0,
              calendar_day: 28,
            },
            {
              order: 3,
              expected_settlement_date: '2025-07-21',
              total_amount_cents: 76537,
              subtotal_amount_cents: 75000,
              interest_amount_cents: 0,
              calendar_day: 42,
            },
            {
              order: 4,
              expected_settlement_date: '2025-08-04',
              total_amount_cents: 76537,
              subtotal_amount_cents: 75000,
              interest_amount_cents: 0,
              calendar_day: 56,
            },
          ],
          discount_amount_cents: 0,
        },
        {
          id: '289a1359-f3eb-47dd-8f36-3bae37ce86f5',
          total_amount_cents: 315000,
          subtotal_amount_cents: 300000,
          interest_amount_cents: 0,
          available: false,
          interest_rate_bps: 0,
          merchant_service_fee_rate_bps: 500,
          merchant_service_fee_amount_cents: 15000,
          installment_quantity: 4,
          installments_interval: [21, 42, 63, 84],
          installments: [
            {
              order: 1,
              expected_settlement_date: '2025-06-30',
              total_amount_cents: 78750,
              subtotal_amount_cents: 75000,
              interest_amount_cents: 0,
              calendar_day: 21,
            },
            {
              order: 2,
              expected_settlement_date: '2025-07-21',
              total_amount_cents: 78750,
              subtotal_amount_cents: 75000,
              interest_amount_cents: 0,
              calendar_day: 42,
            },
            {
              order: 3,
              expected_settlement_date: '2025-08-11',
              total_amount_cents: 78750,
              subtotal_amount_cents: 75000,
              interest_amount_cents: 0,
              calendar_day: 63,
            },
            {
              order: 4,
              expected_settlement_date: '2025-09-01',
              total_amount_cents: 78750,
              subtotal_amount_cents: 75000,
              interest_amount_cents: 0,
              calendar_day: 84,
            },
          ],
          discount_amount_cents: 0,
        },
      ],
    },
    origin: 'sdk',
    created_at: '2023-07-07T19:24:23.721429Z',
    status: PurchaseIntentionStatus.Pending,
  })

export const PurchaseIntentionWithDiscountAPIMock =
  new MockFactory<PurchaseIntentionResponse>({
    id: 'purchase-intention-id',
    supplier_name: 'Frexco',
    supplier_company_id: JOHN_WICK_SELLER_ID,
    merchant_company_id: 'acb9969b-a8b1-4979-aa8e-a6be12edb34e',
    merchant_document_number: '06331795000105',
    email: 'celtino1@tino.com.br',
    url_callback: 'https://sandbox-cart-sample.firebaseapp.com/callback',
    external_id: 'extenal_id-test-payment-link-1',
    amount_cents: 100000,
    contact: {
      phone: '5511911111111',
      channel: 'whatsapp',
    },
    banner: {
      text: 'Desconto Tino!',
    },
    has_pending_otp_verify: false,
    discount_amount_cents: 0,
    payment_options: {
      [Plan.WEEKLY]: [
        {
          id: '7-option-1',
          total_amount_cents: 100000,
          subtotal_amount_cents: 100000,
          discount_amount_cents: 100,
          interest_amount_cents: 0,
          interest_rate_bps: 0,
          installment_quantity: 1,
          installments_interval: [7],
          installments: [
            {
              order: 1,
              expected_settlement_date: '2023-05-02',
              total_amount_cents: 100000,
              subtotal_amount_cents: 0,
              interest_amount_cents: 0,
              calendar_day: 28,
            },
          ],
          available: true,
          merchant_service_fee_amount_cents: 100,
          merchant_service_fee_rate_bps: 0,
        },
        {
          id: '7-option-2',
          total_amount_cents: 100000,
          subtotal_amount_cents: 100000,
          discount_amount_cents: 100,
          interest_amount_cents: 0,
          interest_rate_bps: 0,
          installment_quantity: 1,
          installments_interval: [7, 14],
          installments: [
            {
              order: 1,
              expected_settlement_date: '2023-05-02',
              total_amount_cents: 50000,
              subtotal_amount_cents: 0,
              interest_amount_cents: 0,
              calendar_day: 28,
            },
            {
              order: 2,
              expected_settlement_date: '2023-05-09',
              total_amount_cents: 50000,
              subtotal_amount_cents: 0,
              interest_amount_cents: 0,
              calendar_day: 28,
            },
          ],
          available: true,
          merchant_service_fee_amount_cents: 100,
          merchant_service_fee_rate_bps: 0,
        },
      ],
      [Plan.BIWEEKLY]: [
        {
          id: '14-option-1',
          total_amount_cents: 100000,
          subtotal_amount_cents: 100000,
          discount_amount_cents: 1000,
          interest_amount_cents: 0,
          interest_rate_bps: 0,
          installment_quantity: 1,
          installments_interval: [14],
          installments: [
            {
              order: 1,
              expected_settlement_date: '2023-05-02',
              total_amount_cents: 100000,
              subtotal_amount_cents: 0,
              interest_amount_cents: 0,
              calendar_day: 28,
            },
          ],
          available: true,
          merchant_service_fee_amount_cents: 1000,
          merchant_service_fee_rate_bps: 0,
        },
      ],
      [Plan.MONTHLY]: [
        {
          id: '28-option-1',
          total_amount_cents: 100000,
          subtotal_amount_cents: 100000,
          discount_amount_cents: 0,
          interest_amount_cents: 1000,
          interest_rate_bps: 0,
          installment_quantity: 1,
          installments_interval: [28],
          installments: [
            {
              order: 1,
              expected_settlement_date: '2023-05-22',
              total_amount_cents: 100000,
              subtotal_amount_cents: 0,
              interest_amount_cents: 0,
              calendar_day: 28,
            },
          ],
          available: true,
          merchant_service_fee_amount_cents: 0,
          merchant_service_fee_rate_bps: 0,
        },
        {
          id: '28-option-2',
          total_amount_cents: 100000,
          subtotal_amount_cents: 100000,
          discount_amount_cents: 0,
          interest_amount_cents: 2500,
          interest_rate_bps: 0,
          installment_quantity: 2,
          installments_interval: [28, 56],
          installments: [
            {
              order: 1,
              expected_settlement_date: '2023-05-22',
              total_amount_cents: 50000,
              subtotal_amount_cents: 50000,
              interest_amount_cents: 1250,
              calendar_day: 28,
            },
            {
              order: 2,
              expected_settlement_date: '2023-06-19',
              total_amount_cents: 50000,
              subtotal_amount_cents: 50000,
              interest_amount_cents: 1250,
              calendar_day: 28,
            },
          ],
          available: true,
          merchant_service_fee_amount_cents: 0,
          merchant_service_fee_rate_bps: 0,
        },
      ],
    },
    origin: 'sdk',
    created_at: '2023-07-07T19:24:23.721429Z',
    status: PurchaseIntentionStatus.Pending,
  })

export const PurchaseIntentionWithCashPaymentAPIMock =
  new MockFactory<PurchaseIntentionResponse>({
    id: 'purchase-intention-id',
    supplier_name: 'Samsung',
    supplier_company_id: JOHN_WICK_SELLER_ID,
    merchant_company_id: 'acb9969b-a8b1-4979-aa8e-a6be12edb34e',
    merchant_document_number: '06331795000105',
    email: 'celtino1@tino.com.br',
    url_callback: 'https://sandbox-cart-sample.firebaseapp.com/callback',
    external_id: 'extenal_id-test-payment-link-1',
    amount_cents: 100000,
    contact: {
      phone: '5511911111111',
      channel: 'whatsapp',
    },
    banner: {},
    discount_amount_cents: 0,
    has_pending_otp_verify: false,
    payment_options: {
      [Frequency.ONE_TIME]: [
        {
          id: '1-option-1',
          total_amount_cents: 100000,
          subtotal_amount_cents: 100000,
          interest_amount_cents: 0,
          available: false,
          interest_rate_bps: 0,
          merchant_service_fee_rate_bps: 0,
          merchant_service_fee_amount_cents: 0,
          installment_quantity: 1,
          installments_interval: [1],
          installments: [
            {
              order: 1,
              expected_settlement_date: '2024-10-28',
              total_amount_cents: 5000,
              subtotal_amount_cents: 5000,
              interest_amount_cents: 0,
              calendar_day: 1,
            },
          ],
          discount_amount_cents: 0,
        },
      ],
      [Plan.WEEKLY]: [
        {
          id: '7-option-1',
          total_amount_cents: 100000,
          subtotal_amount_cents: 100000,
          discount_amount_cents: 100,
          interest_amount_cents: 0,
          interest_rate_bps: 0,
          installment_quantity: 1,
          installments_interval: [7],
          installments: [
            {
              order: 1,
              expected_settlement_date: '2023-05-02',
              total_amount_cents: 100000,
              subtotal_amount_cents: 0,
              interest_amount_cents: 0,
              calendar_day: 28,
            },
          ],
          available: true,
          merchant_service_fee_amount_cents: 0,
          merchant_service_fee_rate_bps: 0,
        },
      ],
      [Plan.BIWEEKLY]: [
        {
          id: '14-option-1',
          total_amount_cents: 100000,
          subtotal_amount_cents: 100000,
          discount_amount_cents: 1000,
          interest_amount_cents: 0,
          interest_rate_bps: 0,
          installment_quantity: 1,
          installments_interval: [7, 14],
          installments: [
            {
              order: 1,
              expected_settlement_date: '2023-05-02',
              total_amount_cents: 100000,
              subtotal_amount_cents: 0,
              interest_amount_cents: 0,
              calendar_day: 28,
            },
          ],
          available: true,
          merchant_service_fee_amount_cents: 0,
          merchant_service_fee_rate_bps: 0,
        },
      ],
      [Plan.MONTHLY]: [
        {
          id: '28-option-1',
          total_amount_cents: 100000,
          subtotal_amount_cents: 100000,
          discount_amount_cents: 0,
          interest_amount_cents: 1000,
          interest_rate_bps: 0,
          installment_quantity: 1,
          installments_interval: [28],
          installments: [
            {
              order: 1,
              expected_settlement_date: '2023-05-22',
              total_amount_cents: 100000,
              subtotal_amount_cents: 0,
              interest_amount_cents: 0,
              calendar_day: 28,
            },
          ],
          available: true,
          merchant_service_fee_amount_cents: 0,
          merchant_service_fee_rate_bps: 0,
        },
        {
          id: '28-option-2',
          total_amount_cents: 102500,
          subtotal_amount_cents: 100000,
          discount_amount_cents: 0,
          interest_amount_cents: 2500,
          interest_rate_bps: 0,
          installment_quantity: 2,
          installments_interval: [28, 56],
          installments: [
            {
              order: 1,
              expected_settlement_date: '2023-05-22',
              total_amount_cents: 51250,
              subtotal_amount_cents: 50000,
              interest_amount_cents: 1250,
              calendar_day: 28,
            },
            {
              order: 2,
              expected_settlement_date: '2023-06-19',
              total_amount_cents: 51250,
              subtotal_amount_cents: 50000,
              interest_amount_cents: 1250,
              calendar_day: 28,
            },
          ],
          available: true,
          merchant_service_fee_amount_cents: 0,
          merchant_service_fee_rate_bps: 0,
        },
      ],
    },
    origin: 'sdk',
    created_at: '2023-07-07T19:24:23.721429Z',
    status: PurchaseIntentionStatus.Pending,
  })
